import { Button } from "primereact/button";

export default function DashboardErrorState({ message, onRetry }) {
  return (
    <section className="_welCome_fincoBox">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div
              className="d-flex justify-content-center align-items-center p-5"
              style={{ minHeight: "40vh" }}
            >
              <div className="text-center">
                <p className="text-danger mb-2">{message}</p>
                <Button
                  label="Retry"
                  icon="pi pi-refresh"
                  className="mt-2"
                  onClick={onRetry}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
